var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckbox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 29009"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 9198",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Checked-box"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.454 1.968A2.8 2.8 0 0 0 1.987 4.4a44.318 44.318 0 0 0 0 10.3 2.8 2.8 0 0 0 2.467 2.43 46.118 46.118 0 0 0 10.16 0 2.8 2.8 0 0 0 2.466-2.43 44.315 44.315 0 0 0 .243-7.4.225.225 0 0 1 .066-.171l1.168-1.168a.223.223 0 0 1 .381.14 46 46 0 0 1-.182 8.8 4.483 4.483 0 0 1-3.956 3.906 47.815 47.815 0 0 1-10.535 0 4.483 4.483 0 0 1-3.954-3.914 46 46 0 0 1 0-10.693A4.483 4.483 0 0 1 4.266.291a47.8 47.8 0 0 1 10.534 0 4.486 4.486 0 0 1 1.979.718.215.215 0 0 1 .029.333l-.9.9a.238.238 0 0 1-.281.037 2.8 2.8 0 0 0-1.011-.315 46.116 46.116 0 0 0-10.162.004z",
    transform: "translate(2.141 2.268)",
    style: {
      fill: "#1bc47d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "M14.937 1.44A.844.844 0 0 0 13.744.247L4.218 9.773 1.44 7A.844.844 0 0 0 .247 8.188l3.374 3.374a.843.843 0 0 0 1.193 0z",
    transform: "translate(6.894 3.663)",
    style: {
      fill: "#1bc47d"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckbox);
export default __webpack_public_path__ + "static/media/checkbox.5db47e245f80f4896c89f0c160777d16.svg";
export { ForwardRef as ReactComponent };